var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
var SidebarBodyAccordion = function (_a) {
    var orderDetails = _a.orderDetails;
    var _b = __read(useState([]), 2), expandedKeys = _b[0], setExpandedKeys = _b[1];
    var itemRefs = useRef([]);
    useEffect(function () {
        if (!expandedKeys)
            return;
        var keys = Array.isArray(expandedKeys) ? expandedKeys : [expandedKeys];
        keys.forEach(function (key) {
            var index = Number(key);
            var el = itemRefs.current[index];
            if (el) {
                debounce(function () {
                    return el.scrollIntoView({ behavior: "smooth", block: "start" });
                });
            }
        });
    }, [expandedKeys]);
    return (React.createElement(Accordion, { alwaysOpen: true, onSelect: function (eventKey) {
            setExpandedKeys(eventKey);
        } }, orderDetails.map(function (section, index) {
        var eventKey = index.toString();
        var isExpanded = expandedKeys.includes(eventKey);
        return (React.createElement(Accordion.Item, { eventKey: String(index), key: index.toString() },
            React.createElement(Accordion.Header, { className: "pe-0" },
                React.createElement("div", { className: "accordion-header d-flex justify-content-between w-100" },
                    React.createElement("div", { className: "accordion-header align-items-center" },
                        section.icon,
                        React.createElement("span", { className: "accordion-header-text DMSanN_16_400" }, section.section)),
                    React.createElement("div", { className: "arrow-wrap" },
                        React.createElement("i", { className: isExpanded
                                ? "chevron edel-icon-arrow-up txt-han-blue"
                                : "chevron edel-icon-arrow-down txt-han-blue" })))),
            React.createElement(Accordion.Body, { ref: function (el) {
                    return (itemRefs.current[index] = el);
                } },
                React.createElement("div", { className: "accordion-item-details" }, section.data.map(function (item, _index) { return (React.createElement(React.Fragment, null,
                    React.createElement("div", { key: _index.toString(), className: "details-section" },
                        React.createElement("span", { className: "DMSanN_14_300 txt-purple-navy text-font" },
                            item.label, item === null || item === void 0 ? void 0 :
                            item.labelIcon),
                        (item === null || item === void 0 ? void 0 : item.icon) ? (React.createElement("div", { className: "d-flex gap-1 align-items-center cursor-pointer" }, item === null || item === void 0 ? void 0 :
                            item.icon,
                            React.createElement("span", { className: "DMSanN_14_400 ".concat(item === null || item === void 0 ? void 0 : item.className, " fw-500") }, item.value))) : item.type === "link" ? (React.createElement("span", { className: "RobotoR_14_400 txt-han-blue cursor-pointer" },
                            React.createElement("u", null, item.value ? item.value : "-"))) : (React.createElement("span", { className: "".concat((item === null || item === void 0 ? void 0 : item.valueClassName)
                                ? item === null || item === void 0 ? void 0 : item.valueClassName
                                : "RobotoR_14_400", " txt-midnight-blue-shade2 text-end"), style: { width: item === null || item === void 0 ? void 0 : item.size } }, item.value ? item.value : "-"))),
                    (item === null || item === void 0 ? void 0 : item.siblingComponent) && (item === null || item === void 0 ? void 0 : item.siblingComponent))); })))));
    })));
};
export default SidebarBodyAccordion;
